/**
 * s229 (D-229.68(b), D-229.84): the sections whose rows are saved as TYPED records through
 * `POST /api/clients/:id/typed-rows`. The server's field map (`server/persons/pilot-map.ts`,
 * PILOT_RECORD_SECTIONS) is the source; this list is what the client may ask of it, and
 * `typed-sections-parity.test.ts` keeps the two identical.
 */
import { SECTION_SLUGS } from "./sections";
import { BENEFICIARIES_SLUG } from "../essentials-spec";

export const TYPED_ROW_SECTION_SLUGS: readonly string[] = [
  SECTION_SLUGS.LEGAL_YOUR_EXECUTOR,
  BENEFICIARIES_SLUG,
  SECTION_SLUGS.LEGAL_PROFESSIONAL_CONTACTS,
  SECTION_SLUGS.LEGAL_BUSINESS_CONTACTS,
  SECTION_SLUGS.FAMILY_FRIENDS_AND_PETS_IMPORTANT_CONTACTS,
  SECTION_SLUGS.CHILDREN_DEPENDENTS_OVERVIEW,
  SECTION_SLUGS.FAMILY_PETS,
  // s229 (D-229.85–.90): the legal documents. No chapter-one screen writes them yet; classic pages keep the cell path.
  SECTION_SLUGS.LEGAL_IMPORTANT_DOCUMENTS,
  SECTION_SLUGS.LEGAL_POWERS_OF_ATTORNEY,
  SECTION_SLUGS.LEGAL_BUSINESS_DOCUMENTS,
  // s229 (D-229.93–.95): About You — the plan's "you" person; its card saves with row id null.
  SECTION_SLUGS.ABOUT_YOU,
  // s229 (D-229.111): the bank and investment accounts.
  SECTION_SLUGS.FINANCIAL_BANK_ACCOUNTS,
  SECTION_SLUGS.FINANCIAL_INVESTMENTS_RRSP,
  // s230 PhysicalAsset: properties, vehicles and valuables.
  SECTION_SLUGS.ASSETS_PROPERTIES,
  SECTION_SLUGS.ASSETS_VEHICLE_LIST,
  SECTION_SLUGS.ASSETS_VALUABLES,
  // s231 FinancialObligation (D-231.13): debts, recurring services and rentals.
  SECTION_SLUGS.FINANCIAL_DEBTS_LIABILITIES,
  SECTION_SLUGS.FINANCIAL_AND_INSURANCE_PRE_AUTHORIZED_DEBITS,
  SECTION_SLUGS.FINANCIAL_AND_INSURANCE_HOUSING,
  // s232 DigitalAccount (D-232.30): government portals, online accounts and cloud storage (typed in place).
  SECTION_SLUGS.PASSWORD_LOG_GOVERNMENT_TAX,
  SECTION_SLUGS.PASSWORD_LOG_ONLINE_ACCOUNTS_COMMUNITIES,
  SECTION_SLUGS.PASSWORD_LOG_DIGITAL_FILES_CLOUD_STORAGE,
  // s232 Insurance (D-232.60): insurance policies and health insurance (typed in place).
  SECTION_SLUGS.FINANCIAL_AND_INSURANCE_INSURANCE_POLICIES,
  SECTION_SLUGS.PERSONAL_INFORMATION_HEALTH_INSURANCE,
  // s232 Income (D-232.90): income and pensions (typed in place).
  SECTION_SLUGS.FINANCIAL_INCOME_PENSIONS,
  // s233 GovernmentID (D-232.95): government IDs (typed in place; the locked rows keep their id and lock).
  SECTION_SLUGS.PERSONAL_INFORMATION_GOVERNMENT_IDS,
  // s233 Wish (D-233.32): funeral wishes, letters, and the message to the executor (typed in place).
  SECTION_SLUGS.INSTRUCTIONS_FOR_EXECUTORS_FUNERAL_WISHES,
  SECTION_SLUGS.INSTRUCTIONS_FOR_EXECUTORS_LETTERS,
  SECTION_SLUGS.INSTRUCTIONS_FOR_EXECUTORS_EXECUTOR_INSTRUCTIONS,
  // s233 Where Are They? and Business (D-233.44): typed in place.
  SECTION_SLUGS.INSTRUCTIONS_FOR_EXECUTORS_WHERE_ARE_THEY,
  SECTION_SLUGS.FINANCIAL_BUSINESS_SELF_EMPLOYMENT,
  // s233 Taxes (D-233.80): typed in place.
  SECTION_SLUGS.FINANCIAL_TAXES,
  // s233 Career (D-233.84): Employment History, on income_sources (typed in place).
  SECTION_SLUGS.PERSONAL_INFORMATION_CAREER,
  // s232 (chapter two PR C, ruling 4): Safes and Locked Places — located_items.
  SECTION_SLUGS.ASSETS_SAFES_LOCKED_PLACES,
  // s234 part 5 (D-233.43(2)(3), D-234.49–.52): Devices and Primary Email (typed in place), and Protect Your Access (a
  // card whose answers live on their rows and on the secure file's record).
  SECTION_SLUGS.PASSWORD_LOG_DEVICES_LOCAL_ACCESS,
  SECTION_SLUGS.PASSWORD_LOG_PRIMARY_EMAIL_IDENTITY_ACCOUNTS,
  SECTION_SLUGS.PROTECT_YOUR_ACCESS,
];

export function isTypedRowSection(slug: string | null | undefined): boolean {
  return !!slug && TYPED_ROW_SECTION_SLUGS.includes(slug);
}
